var React = require('react');

function Bars (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.5 3h19a1.4 1.4 0 000-2.8h-19a1.4 1.4 0 000 2.7zm19 2.6h-19a1.4 1.4 0 000 2.8h19a1.4 1.4 0 000-2.8zm0 5.5h-19a1.4 1.4 0 000 2.7h19a1.4 1.4 0 000-2.7z"}));
}

Bars.defaultProps = {"viewBox":"0 0 22 14"};

module.exports = Bars;

Bars.default = Bars;
